<template>
  <div class="sx-company">
    <el-select v-model="form.companyId" placeholder="请选择保险公司" :filterable="true" clearable :disabled="isDisabled"
      :filter-method="filterCompany" @clear="companyClear" class="el-select-90" @change="supplierChange">
      <el-option v-for="item in companies" :key="item.code" :label="item.name" :value="item.code"></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: 'yblSxCompany',
  data () {
    return {
      form: {
        companyId: ''
      },
      companies: [],
      defaultCompanies: [],
      allCompanies: []
    }
  },
  model: {
    prop: 'item',
    event: 'change'
  },
  props: {
    item: {
      type: String,
      default: () => {
        return ''
      }
    },
    isDisabled: false
  },
  watch: {
    'item': function (newVal, oldVal) {
      console.log('item', newVal, oldVal)
      if (!newVal) {
        this.form.companyId = ''
      }
      this.form.companyId = newVal
    }
  },
  created () {
    this.getCompany()
  },
  methods: {
    getCompany () {
      this.$store.dispatch('company').then(res => {
        console.log(res)
        let companies = res.data.filter((item, index) => { return index < 20 })
        this.companies = companies
        this.defaultCompanies = companies
        this.allCompanies = res.data
      })
    },
    filterCompany (val) {
      if (val) {
        this.companies = this.allCompanies.filter(item => item.name.includes(val.toLowerCase()))
      } else {
        this.companies = this.defaultCompanies
      }
    },
    companyClear () {
      this.companies = this.defaultCompanies
    },
    clear () {
      this.form.companyId = ''
      this.companies = this.defaultCompanies
    },
    supplierChange (val) {
      this.$emit('change', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sxCompany.vue